import $ from 'jquery';
import * as React from 'react';
import { Link } from 'react-router-dom';
import CONSTANT from '../../constant';
import { getCookie } from '../../utils';
import Logo from './../../assets/images/logo.png';

class AdminHeader extends React.Component<any, any>{
    componentDidMount() {
        // $('.left-menu').height(document.body.scrollHeight);
        $('.left-menu').height(window.outerHeight);
    }

    render() {
        const ud = getCookie(CONSTANT.cookie.userDetail);
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="left-menu">
                        <div className="logo">
                            <Link to={CONSTANT.component.userFileList.url}><img src={Logo} /></Link>
                        </div>
                        <ul>
                            <li>
                                <Link to={CONSTANT.component.adminLeaveManager.url}>
                                    <i className="fa fa-list-ul" /> Leave Balance
                                </Link>
                            </li>
                            <li>
                                <Link to={CONSTANT.component.adminOrganisationLeaveRequestList.url}>
                                    <i className="fa fa-list-ul" /> Org. Leave Request
                                </Link>
                            </li>
                            <li>
                                <Link to={CONSTANT.component.adminOrganisationEncashmentRequestList.url}>
                                    <i className="fa fa-list-ul" /> Org. Encashment Request
                                </Link>
                            </li>
                            <li>
                                <Link to={CONSTANT.component.adminSearchLeave.url}>
                                    <i className="fa fa-list-ul" /> Leave Availed Report
                                </Link>
                            </li>
                            <li>
                                <Link to={CONSTANT.component.adminMonthlyLeaveReport.url}>
                                    <i className="fa fa-list-ul" /> Monthly Report
                                </Link>
                            </li>
                            <li>
                                <Link to={CONSTANT.component.adminHolidayList.url}>
                                    <i className="fa fa-list-ul" /> Holidays
                                </Link>
                            </li>
                            <li>
                                <Link to={CONSTANT.component.adminBulkUploadLeaveBalance.url}>
                                    <i className="fa fa-list-ul" /> Upload Leave Balance
                                </Link>
                            </li>
                            <li>
                                <Link to={CONSTANT.component.adminLeaveBalanceUpdateLog.url}>
                                    <i className="fa fa-list-ul" /> Balance Update Log
                                </Link>
                            </li>
                            <li>
                                <Link to={CONSTANT.component.userFileList.url}>
                                    <i className="fa fa-user-circle" /> Back to Profile
                                </Link>
                            </li>
                            <li>
                                <Link to={CONSTANT.component.logout.url}>
                                    <i className="fa fa-sign-out" /> Log out
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default AdminHeader;
